<template>
  <generic-modal :title="$t('loan application rejection')" ref="generic_modal">
    <form>
      <div class="field">
        <label class="label">{{ $t("reason") }}</label>
        <div class="control">
          <textarea class="textarea" v-model="meta.reason" rows="2"></textarea>
        </div>
      </div>
    </form>

    <div class="notification is-danger" v-if="error" v-html="error"></div>

    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { generate_error_message_text, del, post, put, get } from "@/utils";

export default {
  name: "ApplicationRejectionModal",
  components: { GenericModal, GenericDropdown },
  data() {
    let v = this;
    return {
      meta: {},
      error: "",
      application_uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      return !this.meta.reason || this.meta.reason.trim().length === 0;
    },
  },
  methods: {
    open(uuid = null) {
      let v = this;
      v.application_uuid = uuid;
      v.$refs.generic_modal.show_modal();
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    save() {
      let v = this;
      if (v.is_form_invalid) return;

      let data = { ...v.meta };

      if (v.application_uuid) {
        data.uuid = v.application_uuid;
        post("/loan/application/reject", { uuid: v.application_uuid, ...data })
          .then(() => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.error = "";
      v.application_uuid = "";
    },
  },
  watch: {},
};
</script>
